(() => {
  let timer;
  function update(root = document) {
    const today = new Date();
    const completion = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 28, 12);
    const dateTime = [completion.getFullYear(), String(completion.getMonth() + 1).padStart(2, '0'), String(completion.getDate()).padStart(2, '0')].join('-');
    const label = completion.toLocaleDateString(document.documentElement.lang || 'en', { year: 'numeric', month: 'long', day: 'numeric' });
    const dates = [...root.querySelectorAll('[data-joa-completion-date]')];
    if (root.matches?.('[data-joa-completion-date]')) dates.push(root);
    dates.forEach(node => {
      if (node.dateTime !== dateTime) node.dateTime = dateTime;
      if (node.textContent !== label) node.textContent = label;
    });
    clearTimeout(timer);
    const tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
    timer = setTimeout(() => update(), tomorrow.getTime() - today.getTime() + 1000);
  }
  function create(label) {
    const note = document.createElement('p');
    note.className = 'joa-completion-estimate joa-completion-estimate--shared';
    const date = document.createElement('time');
    date.dataset.joaCompletionDate = '';
    note.append(document.createTextNode(label + ' '), date);
    update(note);
    return note;
  }
  window.JoaCompletionDate = { update, create };
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node instanceof Element && (node.matches('[data-joa-completion-date]') || node.querySelector('[data-joa-completion-date]'))) update(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pageshow', () => update());
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  update();
})();
